<div #alert class="alert alert-warning alert-dismissible fade show {{ alertType }}" role="alert">
    <button type="button" class="close {{ closeType }}" aria-label="Close" (click)="closeAlert()"
        [attr.data-automation-id]="'dismiss-alert-btn-close'">
        <span aria-hidden="true">&times;</span>
    </button>
    <div class='alert-content'>
        <app-locale localeKey='{{localeKey}}' localeView='{{localeView}}'></app-locale>
        <ng-content select="[additionalContent]"></ng-content>
    </div>
</div>